// Branding images (office letterheads, invoice signature).
//
// These live in the `branding` Storage bucket and are referenced by public URL.
// Before that they were inlined into app_settings.invoiceBranding as base64
// `dataUrl` strings, which is why both shapes are still accepted here: a record
// that has not been through scripts/migrate-invoice-branding-to-storage.mjs
// keeps working, and so does one saved by an older build.

/**
 * Resolve a branding image record to something usable as an <img> src.
 * Accepts { url }, { dataUrl }, or a bare string; returns '' when unset.
 */
export function resolveBrandingImageSrc(image) {
  if (!image) return '';
  if (typeof image === 'string') return image.length > 10 ? image : '';
  if (typeof image !== 'object') return '';
  if (typeof image.url === 'string' && image.url) return image.url;
  if (typeof image.dataUrl === 'string' && image.dataUrl.length > 10) return image.dataUrl;
  return '';
}

/** True when the record points at a stored object rather than inline bytes. */
export function isStoredBrandingImage(image) {
  return !!(image && typeof image === 'object' && typeof image.url === 'string' && image.url);
}

export default resolveBrandingImageSrc;
